import { actionTypes } from '~/constants';

const initialState = {
    CognitoUser: null,
    profile: {},
    is_loaded: false
};

export default (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SWITCH_USER:
            return {
                ...state,
                CognitoUser: action.CognitoUser,
            }
        case actionTypes.UPDATE_PROFILE:
            return {
                ...state,
                profile: action.profile,
                is_loaded: true
            }
        case actionTypes.DELETE_PROFILE:
            return {
                ...state,
                CognitoUser: null
            }
        default:
            return state;
    }
}
